/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `s1` - waterlevel
 * * `vol1` - volume
 * * `q` - discharge
 * * `u1` - velocity
 * @export
 */
export const MeasureSpecificationVariableEnum = {
  S1: "s1",
  VOL1: "vol1",
  Q: "q",
  U1: "u1",
} as const;
export type MeasureSpecificationVariableEnum =
  (typeof MeasureSpecificationVariableEnum)[keyof typeof MeasureSpecificationVariableEnum];

export function instanceOfMeasureSpecificationVariableEnum(value: any): boolean {
  for (const key in MeasureSpecificationVariableEnum) {
    if (Object.prototype.hasOwnProperty.call(MeasureSpecificationVariableEnum, key)) {
      if (
        MeasureSpecificationVariableEnum[key as keyof typeof MeasureSpecificationVariableEnum] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function MeasureSpecificationVariableEnumFromJSON(
  json: any
): MeasureSpecificationVariableEnum {
  return MeasureSpecificationVariableEnumFromJSONTyped(json, false);
}

export function MeasureSpecificationVariableEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MeasureSpecificationVariableEnum {
  return json as MeasureSpecificationVariableEnum;
}

export function MeasureSpecificationVariableEnumToJSON(
  value?: MeasureSpecificationVariableEnum | null
): any {
  return value as any;
}

export function MeasureSpecificationVariableEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): MeasureSpecificationVariableEnum {
  return value as MeasureSpecificationVariableEnum;
}
